<style scoped lang="less">
    .container {
      .line-chart{
        width: 100%;
        height: 460px;
        padding-top: 2%;
        border: 1px solid #e5e5e5;
      }
    }
</style>

<template>
    <div class="container">
      <div id="lineChart" class="fixed-margin-top line-chart" ref="lineChart"></div>
    </div>
</template>

<script>
import Vue from 'vue'
// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts'
// 引入折线图
import 'echarts/lib/chart/line'
// 引入提示框和图例组件
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legendScroll'

export default {
  components:{

  },
  props: {
    line: {}
  },
  data(){
    return {
       lineData: {
          leftTxt: '',
          rightTxt: '',
          date: [],
          leftData: [],
          rightData: [],
       },
    };
  },
  watch: {
      'line': function(){
          this.drawLine(); //初始化折线图
          this.init(); // 折线图自适应
      },
  },
  methods:{
    init () {
        //折线图宽高自适应
        if (!this.timer) {
            this.timer = true;
            let self = this;
            setTimeout(() => {
              window.onresize = function () {
                //判断当前页面是否有折线图
                if (self.$refs.lineChart){
                    self.chart = echarts.init(self.$refs.lineChart);
                    self.chart.resize();
                    this.timer = false;
                }
              };
            }, 20);
        }
    },
    formatData(){
        let textObj = this.line.text;
        let textArray = [];
        let valArray = [];
        for (let key in textObj) {
          valArray.push(key);
          textArray.push(textObj[key]);
        }
        this.lineData = {
            leftTxt: textArray[0],
            rightTxt: textArray[1],
            date: this.line.date,
            leftData: this.line[valArray[0]],
            rightData: this.line[valArray[1]],
        }
    },
    drawLine() {
      if (this.chart) this.chart.clear();
      this.chart = echarts.init(this.$refs.lineChart);
      this.formatData();

      function calMax(arr) {
          var max = Math.max.apply(null,arr);
          var maxint = Math.ceil(max / 10);// 向上取整
          var maxval = maxint * 10 === 0 ? 1 : maxint * 10;// 最终设置的最大值
          return maxval;// 输出最大值
      }
      var leftData = this.lineData.leftData;
      var rightData = this.lineData.rightData;
      var maxappreg = calMax(leftData) ;//左侧Y轴值
      var maxactive = calMax(rightData);//右侧Y轴值
      var interval_left= maxappreg/5 < 1 ? 1 : maxappreg/5;//左轴间隔
      var interval_right= maxactive/5 < 1 ? 1 : maxactive/5;//右轴间隔

      // 把配置和数据放这里
      this.chart.setOption({
        tooltip: {
            trigger: 'axis'
        },
        legend: {
          data:[this.lineData.leftTxt,this.lineData.rightTxt],
          right: '2%',
          top: '-1%',
          itemWidth: 16,
          itemHeight: 12
        },
        grid: {
            left: '80px',
            right: '80px',
            bottom: '60px'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,   //x轴刻度从0开始
          axisLabel: {
               color: '#333',
               //interval: 0,   //x轴刻度间隔
               rotate: ((this.lineData.date && this.lineData.date.length) < 15 ? 0 : 40), //x轴刻度大于15时倾斜展示
          },
          axisLine: {
            lineStyle: {
              color: '#e7e7e7'
            }
          },
          data: this.lineData.date
        },
        yAxis: [
        {
          type: 'value',
          name: this.lineData.leftTxt,
          minInterval : 1,  //y轴刻度整数
          nameTextStyle: {
             color: '#888'
          },
          axisLine: {
            lineStyle: {
              color: '#e7e7e7'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#e7e7e7'
            }
          },
          axisLabel: {
            formatter: '{value}',
            color: '#888',
          },
          max:maxappreg,
          //splitNumber:5,
          interval:interval_left,
        },
        {
          type: 'value',
          name: this.lineData.rightTxt,
          minInterval : 1,  //y轴刻度整数
          nameTextStyle: {
             color: '#888'
          },
          axisLine: {
            lineStyle: {
              color: '#e7e7e7'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#e7e7e7'
            }
          },
          axisLabel: {
            formatter: '{value}',
            color: '#888',
          },
          max:maxactive,
          //splitNumber:5,
          interval:interval_right,
        }],
        series: [
          {
            data: leftData,
            name: this.lineData.leftTxt,
            type: 'line',
            color: '#4d7ce6',
            symbol: "circle",   //拐点实心
            smooth: true,
            itemStyle : {
              normal : {
                lineStyle:{
                    color:'#4d7ce6',
                    width: 2,
                },
              }
            },
            animationDelay: function (idx) {
               return idx * 60;
            },
          },
          {
            data: rightData,
            name: this.lineData.rightTxt,
            type: 'line',
            color: '#fe8e68',
            symbol: "circle",   //拐点实心
            smooth: true,
            itemStyle : {
              normal : {
                lineStyle:{
                    color:'#fe8e68',
                    width: 1,
                }
              }
            },
            yAxisIndex: 1,
            animationDelay: function (idx) {
               return idx * 60;
            },
          }
        ],
        animationEasing: 'elasticOut',
        animationDuration: 1000,
        animationDelayUpdate: function (idx) {
            return idx * 60;
        },
      });
    }
  },
  created(){

  },
  mounted(){
        this.drawLine(); //初始化折线图
        this.init(); // 折线图自适应
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chart.vue